import { useCallback, useEffect, useState } from "react";

//#region src/hooks/useMediaQuery.ts
/**
* A hook that returns true if the media query matches.
*
* @param query - The media query string (e.g., "(max-width: 768px)")
* @param initialValue - The initial value before the media query is evaluated (default: false)
* @returns boolean indicating if the media query matches
*
* @example
* ```tsx
* const isMobile = useMediaQuery("(max-width: 768px)");
* const isDesktop = useMediaQuery("(min-width: 1024px)");
* ```
*/
function useMediaQuery(query, initialValue = false) {
	const [matches, setMatches] = useState(initialValue);
	const handleChange = useCallback((event) => {
		setMatches(event.matches);
	}, []);
	useEffect(() => {
		if (typeof window === "undefined") return;
		const mediaQueryList = window.matchMedia(query);
		setMatches(mediaQueryList.matches);
		if (mediaQueryList.addEventListener) mediaQueryList.addEventListener("change", handleChange);
		else mediaQueryList.addListener(handleChange);
		return () => {
			if (mediaQueryList.removeEventListener) mediaQueryList.removeEventListener("change", handleChange);
			else mediaQueryList.removeListener(handleChange);
		};
	}, [query, handleChange]);
	return matches;
}

//#endregion
export { useMediaQuery as default, useMediaQuery };
//# sourceMappingURL=useMediaQuery.mjs.map